import React, { useContext } from 'react';
import { CompanyInfoDetailSection } from './styled';
import { Location } from '@carbon/icons-react';
import { CustomizedTypography } from '@components/Customized';
import {
  CompanyInfoContext,
  CompanyInfoContextValue
} from '../context/CompanyInfoContext';

const CompanyAddress: React.FunctionComponent = () => {
  const context = useContext<CompanyInfoContextValue | null>(
    CompanyInfoContext
  );

  if (!context) return null;

  const { partnerInfo } = context;

  return (
    <CompanyInfoDetailSection>
      <div className="data-row">
        <div className="row-title">
          <Location size={20} />
          <CustomizedTypography>회사주소</CustomizedTypography>
        </div>

        <CustomizedTypography className="row-value">
          {partnerInfo?.fullAddress}
        </CustomizedTypography>
      </div>
    </CompanyInfoDetailSection>
  );
};

export default CompanyAddress;
